import { Container, Flex, Heading, SimpleGrid, Stack, Text, VStack } from '@chakra-ui/react'
import { Link } from 'react-router';
import useMenuList from '../useMenuList'

const ListMenu = () => {
  const menuList = useMenuList();

  const itemsCount = menuList.length;

  return (
    <Container py="16" maxW="5xl">
      <VStack gap="12" align="center">
        <Stack gap={{ base: '4', md: '5' }}>
          <Heading as="h2" textStyle={{ base: 'xl', md: '3xl' }} textAlign="center">
            Por onde deseja começar?
          </Heading>
          <Text color="fg.muted" textStyle={{ base: 'md', md: 'lg' }} textAlign="center">
            Selecione uma opção abaixo para iniciar!
          </Text>
        </Stack>
        <SimpleGrid columns={{ base: 1, lg: itemsCount > 2 ? 3 : itemsCount }} gap="4" alignSelf="stretch">
          {menuList.map((item) => (
            <Link key={item.label} to={`/painel/${item.path}`} style={{ textDecoration: 'none' }}>
              <Stack
                gap="2"
                padding="6"
                bg="bg.muted"
                borderRadius="l3"
                _hover={{
                  bg: 'bg.hover',
                }}
              >
                <Flex alignItems="center" justifyContent="center">
                  {item.icon}
                </Flex>
                <Text textStyle="lg" fontWeight="semibold" color="colorPalette.fg" textAlign="center">
                  {item.label}
                </Text>
              </Stack>
            </Link>
          ))}
        </SimpleGrid>
      </VStack>
    </Container>
  );
};

export default ListMenu;
